import React from "react";
import lazyWithRetry from "./lib/lazywithretry";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Routes
import PublicRoute from "./routes/public";
import DoctorRoute from "./routes/doctor";
import PatientRoute from "./routes/patient";
import ClinicRoute from "./routes/clinic";
import AdminRoute from "./routes/admin";
import ConferenceRoute from "./routes/conferenceRoute";
import UnAuthRoute from "./routes/unauth";

import CallbackRoute from "./routes/callback";
import PaymentRoute from "./routes/paymentRoute";

// Page Components
const AsyncLogin = lazyWithRetry(import("./containers/login/index"));

//Authentication Pages
const AsyncSignUp = lazyWithRetry(import("./containers/signup/index"));

const AsyncClinicSignUp = lazyWithRetry(import("./containers/signup/clinic-signup"));
const AsyncPatientSignUp = lazyWithRetry(import("./containers/signup/patient-signup"));
const AsyncForgotPassword = lazyWithRetry(import("./containers/forgotPassword/index"));
const AsyncResetPassword = lazyWithRetry(import("./containers/resetPassword/index"));
const AsyncVerifyAccount = lazyWithRetry(import("./containers/verifyAccount/index"));
const AsyncTermsnConditions = lazyWithRetry(import("./containers/common/TermsnConditions"));
const AsyncPrivacyPolicy = lazyWithRetry(import("./containers/common/PrivacyPolicy"));
const AsyncFeedbackForm = lazyWithRetry(import("./containers/conference/FeedBackPopup"));

//ADMIN-INCLINIX
const AsyncAdminSignUp = lazyWithRetry(import("./containers/signup/admin-signup"));
const AsyncConfirmMsg = lazyWithRetry(import("./containers/signup/ConfirmMsgPopup"));

//DOCTOR
const AsyncDoctorSchedules = lazyWithRetry(import("./containers/doctor/doctorSchedules/index"));
const AsyncDoctorAppointments = lazyWithRetry(import("./containers/doctor/doctorAppointments/index"));
const AsyncDoctorUploads = lazyWithRetry(import("./containers/common/fileUploads/index"));
const AsyncDoctorProfile = lazyWithRetry(import("./containers/doctor/doctorProfile/index"));
const AsyncDoctorInvites = lazyWithRetry(import("./containers/doctor/doctorInvites/index"));
const AsyncDoctorSettings = lazyWithRetry(import("./containers/doctor/doctorSettings/index"));
const AsyncDoctorCoupon = lazyWithRetry(import("./containers/doctor/doctorcoupon/coupon"));
const AsyncDoctorDashboard = lazyWithRetry(import("./containers/doctor/doctorDashboard/index"));

//CLINIC
// PATIENT
const AsyncPatientSettings = lazyWithRetry(import("./containers/patient/patientSettings/index"));
const AsyncPatientProfile = lazyWithRetry(import("./containers/patient/patientProfile/index"));
const AsyncPatientUploads = lazyWithRetry(import("./containers/common/fileUploads/index"));
const AsyncPatientAppointments = lazyWithRetry(import("./containers/common/appointments/index"));
const AsyncPatientDashboard = lazyWithRetry(import("./containers/patient/dashboard/index"));
const AsyncPastAppointments = lazyWithRetry(import("./containers/patient/dashboard/PastAppointments"));
const AsyncWaitingRoom = lazyWithRetry(import("./containers/common/waitingroom/index"));

const AsyncPatientFailure = lazyWithRetry(import("./containers/common/bookAppointment/components/PaymentFailure"));

// CLINIC
const AsyncClinicDashboard = lazyWithRetry(import("./containers/clinic/dashboard/index"));
const AsyncNewDashboard = lazyWithRetry(import("./containers/clinic/newDashboard/index"));
const AsyncCreatePatient = lazyWithRetry(import("./containers/clinic/createPatient/index"));
const AsyncDoctorSchedule = lazyWithRetry(import("./containers/common/doctorSchedule/index"));
const AsyncBookAppointment = lazyWithRetry(import("./containers/common/bookAppointment/index"));
const AsyncPatientsList = lazyWithRetry(import("./containers/clinic/patientslist/index"));
const AsyncClinicAppointments = lazyWithRetry(import("./containers/common/appointments/index"));
const AsyncClinicProfile = lazyWithRetry(import("./containers/clinic/profile/index"));
const AsyncClinicSettings = lazyWithRetry(import("./containers/clinic/clinicSettings/index"));
const AsyncClinicConfig = lazyWithRetry(import("./containers/clinic/clinicConfiguration/index"));
const AsyncClinicLicense = lazyWithRetry(import("./containers/clinic/licenseManagement/index"));

// ADMIN
const AsyncAdminDashboard = lazyWithRetry(import("./containers/admin/dashboard"));
const AsyncAdminCreateUsers = lazyWithRetry(import("./containers/admin/createUsers/index"));
const AsyncAdminUsers = lazyWithRetry(import("./containers/admin/users/index"));
const AsyncAdminAdvice = lazyWithRetry(import("./containers/admin/advice/index"));
const AsyncAdminReports = lazyWithRetry(import("./containers/admin/reports/index"));
const AsyncAdminSettings = lazyWithRetry(import("./containers/admin/adminSettings/index"));

// CONFERENCE
const AsyncConfSettings = lazyWithRetry(import("./containers/conference/confSettings/index"));
const AsyncGuestConfSettings = lazyWithRetry(import("./containers/conference/confSettings/guestindex"));
const AsyncConfLayout = lazyWithRetry(import("./containers/conference/confLayout"));
const AsyncGuestConfLayout = lazyWithRetry(import("./containers/conference/guestConfLayout"));
const AsyncConferenceAccess = lazyWithRetry(import("./containers/conference/conferenceAccess"));
const AsyncSearchPrescription = lazyWithRetry(import("./containers/searchPrescription/OpenPrescription"));
const AsyncConfirmPayment = lazyWithRetry(import("./containers/common/payments/confirmpayment"));
const AsyncConfirmClinicOrder = lazyWithRetry(import("./containers/common/payments/confirmclinicpayment"));
const AsyncNoLicense = lazyWithRetry(import("./containers/clinic/noLicense/index"));
const AsyncPlaceOrder = lazyWithRetry(import("./containers/placeOrder/index"));
const AsyncSiteNotReached = lazyWithRetry(import("./containers/common/SiteNoteReached"));
const AsyncClinicReports = lazyWithRetry(import("./containers/clinic/clinicReports/index"));
const AsyncDoctorReports = lazyWithRetry(import("./containers/clinic/doctorReports/index"));
const AsyncBillingTable = lazyWithRetry(import("./containers/clinic/clinicReports/allDataTable/billingTable"));
const BotConfLayout = lazyWithRetry(import("./containers/conference/botconflink"));

class AppRoutes extends React.Component {
    componentWillMount() {
        //  sessionStorage.reload = true;
    }

    render() {
        return (
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PublicRoute>
                                <AsyncLogin />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/sign-up"
                        element={
                            <PublicRoute>
                                <AsyncSignUp />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="/sitenotreached"
                        element={
                            <PublicRoute>
                                <AsyncSiteNotReached />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="/place-your-order/:docs"
                        element={
                            <PublicRoute>
                                <AsyncPlaceOrder />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/confirm-clinic"
                        element={
                            <PublicRoute>
                                <AsyncConfirmClinicOrder />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/place-order/:productCode/:qty"
                        element={
                            <PublicRoute>
                                <AsyncPlaceOrder />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/place-your-order/:productCode/:qty"
                        element={
                            <PaymentRoute>
                                <AsyncPlaceOrder />
                            </PaymentRoute>
                        }
                    />

                    <Route
                        path="/no-license"
                        element={
                            <PaymentRoute>
                                <AsyncNoLicense />
                            </PaymentRoute>
                        }
                    />

                    <Route
                        path="/clinic-signup"
                        element={
                            <PublicRoute>
                                <AsyncClinicSignUp />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/patient-signup"
                        element={
                            <PublicRoute>
                                <AsyncPatientSignUp />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="/admin-sign-up"
                        element={
                            <PublicRoute>
                                <AsyncAdminSignUp />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/confirm-msg"
                        element={
                            <PublicRoute>
                                <AsyncConfirmMsg />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path="/forgot-password"
                        element={
                            <PublicRoute>
                                <AsyncForgotPassword />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/reset-password"
                        element={
                            <PublicRoute>
                                <AsyncResetPassword />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/verify-account"
                        element={
                            <PublicRoute>
                                <AsyncVerifyAccount />
                            </PublicRoute>
                        }
                    />

                    {/* <PublicRoute path="/place-order/:productCode/:qty" exact component={AsyncPlaceOrder} {...this.props} /> */}

                    <Route
                        path="/terms-conditions"
                        element={
                            <UnAuthRoute>
                                <AsyncTermsnConditions />
                            </UnAuthRoute>
                        }
                    />
                    <Route
                        path="/patient-concern"
                        element={
                            <UnAuthRoute>
                                <AsyncTermsnConditions />
                            </UnAuthRoute>
                        }
                    />
                    <Route
                        path="/privacy-policy"
                        element={
                            <UnAuthRoute>
                                <AsyncPrivacyPolicy />
                            </UnAuthRoute>
                        }
                    />

                    {/* AFTER LOGIN  */}
                    <Route
                        path="/doctor-schedules"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorSchedules />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-appointments"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorDashboard />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-uploads"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorUploads />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-profile"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorProfile />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-invites"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorInvites />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-coupon"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorCoupon />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/doctor-settings"
                        element={
                            <DoctorRoute>
                                <AsyncDoctorSettings />
                            </DoctorRoute>
                        }
                    />
                    <Route
                        path="/patient-dashboard"
                        element={
                            <PatientRoute>
                                <AsyncPatientDashboard />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/past-appointments"
                        element={
                            <PatientRoute>
                                <AsyncPastAppointments />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/doctor-booking"
                        element={
                            <PatientRoute>
                                <AsyncDoctorSchedule />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/book-appointment/:dId"
                        element={
                            <PatientRoute>
                                <AsyncBookAppointment />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/patient-settings"
                        element={
                            <PatientRoute>
                                <AsyncPatientSettings />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/patient-profile"
                        element={
                            <PatientRoute>
                                <AsyncPatientProfile />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/patient-uploads"
                        element={
                            <PatientRoute>
                                <AsyncPatientUploads />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/confirm-payment"
                        element={
                            <PatientRoute>
                                <AsyncConfirmPayment />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/feedback"
                        element={
                            <PatientRoute>
                                <AsyncFeedbackForm />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/payment-failure/"
                        element={
                            <PatientRoute>
                                <AsyncPatientFailure />
                            </PatientRoute>
                        }
                    />
                    <Route
                        path="/conference-access/:sub/:deviceid"
                        element={
                            <CallbackRoute>
                                <AsyncConferenceAccess />
                            </CallbackRoute>
                        }
                    />

                    <Route
                        path="/clinic-dashboard"
                        element={
                            <ClinicRoute>
                                <AsyncNewDashboard />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/create-patient"
                        element={
                            <ClinicRoute>
                                <AsyncCreatePatient />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/create-patient/:pId"
                        element={
                            <ClinicRoute>
                                <AsyncCreatePatient />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-users"
                        element={
                            <ClinicRoute>
                                <AsyncAdminUsers />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/doctor-schedule/:pId"
                        element={
                            <ClinicRoute>
                                <AsyncDoctorSchedule />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic/book-appointment/:dId/:pId"
                        element={
                            <ClinicRoute>
                                <AsyncBookAppointment />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/patients-list"
                        element={
                            <ClinicRoute>
                                <AsyncPatientsList />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/appointments"
                        element={
                            <ClinicRoute>
                                <AsyncClinicAppointments />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/edit-profile"
                        element={
                            <ClinicRoute>
                                <AsyncClinicProfile />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-settings"
                        element={
                            <ClinicRoute>
                                <AsyncClinicSettings />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-createusers"
                        element={
                            <ClinicRoute>
                                <AsyncAdminCreateUsers />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-config"
                        element={
                            <ClinicRoute>
                                <AsyncClinicConfig />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-license"
                        element={
                            <ClinicRoute>
                                <AsyncClinicLicense />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/confirmclc-payment"
                        element={
                            <ClinicRoute>
                                <AsyncConfirmPayment />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-report"
                        element={
                            <ClinicRoute>
                                <AsyncClinicReports />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/doctor-report"
                        element={
                            <ClinicRoute>
                                <AsyncDoctorReports />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/billing-table"
                        element={
                            <ClinicRoute>
                                <AsyncBillingTable />
                            </ClinicRoute>
                        }
                    />
                    <Route
                        path="/clinic-uploads"
                        element={
                            <ClinicRoute>
                                <AsyncDoctorUploads />
                            </ClinicRoute>
                        }
                    />

                    <Route
                        path="/dashboard"
                        element={
                            <AdminRoute>
                                <AsyncAdminDashboard />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-dashboard"
                        element={
                            <AdminRoute>
                                <AsyncAdminDashboard />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-createusers"
                        element={
                            <AdminRoute>
                                <AsyncAdminCreateUsers />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-users"
                        element={
                            <AdminRoute>
                                <AsyncAdminUsers />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-users/:profile"
                        element={
                            <AdminRoute>
                                <AsyncAdminUsers />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-advice"
                        element={
                            <AdminRoute>
                                <AsyncAdminAdvice />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-reports"
                        element={
                            <AdminRoute>
                                <AsyncAdminReports />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin-settings"
                        element={
                            <AdminRoute>
                                <AsyncAdminSettings />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/conference/:id"
                        element={
                            <ConferenceRoute>
                                <AsyncConfLayout />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/doctor-conference/:id/:uid"
                        element={
                            <ConferenceRoute>
                                <AsyncConfLayout />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/guest-settings/:id"
                        element={
                            <ConferenceRoute>
                                <AsyncGuestConfSettings />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/conference-settings/:id"
                        element={
                            <ConferenceRoute>
                                <AsyncConfSettings />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/doc-conf-settings/:id/:uid"
                        element={
                            <ConferenceRoute>
                                <AsyncConfSettings />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/waiting-room/:id"
                        element={
                            <ConferenceRoute>
                                <AsyncWaitingRoom />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/guest-conference/:id"
                        element={
                            <ConferenceRoute>
                                <AsyncGuestConfLayout />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path="/get-prescription/:id"
                        element={
                            <CallbackRoute>
                                <AsyncSearchPrescription />
                            </CallbackRoute>
                        }
                    />
                    <Route
                        path="/bot-link/:id"
                        element={
                            <ConferenceRoute>
                                <BotConfLayout />
                            </ConferenceRoute>
                        }
                    />
                    <Route
                        path=""
                        element={
                            <PublicRoute>
                                <AsyncLogin />
                            </PublicRoute>
                        }
                    />
                </Routes>
            </Router>
        );
    }
}

export default AppRoutes;
